import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  AfterViewInit,
  HostListener,
  OnInit,
  ViewChild,
  Inject,
  PLATFORM_ID,
  inject,
} from '@angular/core';

import { Facility } from '@digital-platform/rs-cms/domain';
import { RichTextLinkComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { CmsFacilitiesService } from '@digital-platform/rs-cms/services';
import { FacilityLocation } from '@digital-platform/rs-maps/domain';
import { FacilityItemComponent } from '../facility-item/facility-item.component';

@Component({
  selector: 'digital-platform-facility-results',
  imports: [CommonModule, FacilityItemComponent, RichTextLinkComponent],
  standalone: true,
  templateUrl: './facility-results.component.html',
})
export class FacilityResultsComponent implements OnInit, AfterViewInit {
  @Input() facilities!: Facility[] | null;
  @Input() serviceBadgesHeight = 0;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  public isMobile!: boolean;
  private platformId = inject(PLATFORM_ID);
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.setIsMobile();
  }

  constructor(
    private cmsFacilitiesService: CmsFacilitiesService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.setIsMobile();
  }

  setIsMobile(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 1200;
    }
  }

  ngAfterViewInit() {
    this.cmsFacilitiesService.selectedFacility.subscribe(
      (facility: Facility | FacilityLocation | undefined) => {
        if (facility) {
          this.scrollToSelectedFacility(facility);
        }
      }
    );
  }

  public scrollToSelectedFacility(facility: Facility | FacilityLocation) {
    const element = this.el.nativeElement.querySelector(
      `#${this.setFacilityId(facility)}`
    );
    if (element && this.scrollContainer) {
      const childrenArray: HTMLElement[] = Array.from(
        this.scrollContainer.nativeElement.children
      );
      const index = childrenArray.indexOf(element);

      // calculate total offset
      let offset = 0;
      for (let i = 0; i < index; i++) {
        offset += childrenArray[i].getBoundingClientRect().height + 2; // adjust for 2px margin between results
      }
      this.scrollContainer.nativeElement.scrollTop = offset;
    }
  }

  public setFacilityId(facility: Facility | FacilityLocation): string {
    // allows us to scroll to the element with this unique ID
    return `${facility.facility_name}-${facility.city}-${facility.state}`.replace(
      / /g,
      ''
    );
  }

  public get listHeight(): string {
    let baseHeight = 580;
    if (this.facilities && this.isMobile && this.facilities.length <= 2) {
      baseHeight = this.facilities.length === 2 ? 450 : 250;
      baseHeight = this.serviceBadgesHeight ? baseHeight + 185 : baseHeight;
    }

    return this.serviceBadgesHeight
      ? `calc(${baseHeight}px - ${this.serviceBadgesHeight}px)`
      : `${baseHeight}px`;
  }
}
